import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { AdvancedSettingsComponent } from './advanced-settings.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MatSlideToggleModule, MatExpansionModule, GalaxySnackbarModule],
  declarations: [AdvancedSettingsComponent],
  exports: [AdvancedSettingsComponent],
  providers: [],
})
export class AdvancedSettingsModule {}
